module.exports = __webpack_public_path__ + "img/pending-approval-file.b1ff3fb8.png";